module.exports = __webpack_public_path__ + "static/media/banner1.4962168c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/demmeler/images/banner1.jpg
// module id = 479
// module chunks = 0